<script setup lang="ts">
import LoadingAnimation from "./Loading.vue";

const props = defineProps<{
  params?: {
    showLoadingAnimation?: boolean;
    contextMessage?: string;
    getTitle?: (params: Record<string, unknown>) => string;
    getSubtitle?: (params: Record<string, unknown>) => string;
  };
}>();
</script>

<template>
  <div class="no-rows-overlay">
    <LoadingAnimation
      v-if="props?.params?.showLoadingAnimation"
      v-bind="
        props.params.contextMessage !== undefined
          ? { contextMessage: props.params.contextMessage }
          : {}
      "
    />
    <h3 v-else class="mb-2 text-lg text-slate-600">
      {{
        !props?.params?.getTitle
          ? "No Data to Show"
          : props.params.getTitle(props.params)
      }}
    </h3>
    <p v-if="!props?.params?.showLoadingAnimation" class="text-sm">
      {{
        !props?.params?.getSubtitle
          ? ""
          : props.params.getSubtitle(props.params)
      }}
    </p>
  </div>
</template>
